import React from "react";
import {
  Typography,
  Box,
  Button,
  IconButton,
  TextField,
  InputAdornment,
  FormControl,
  OutlinedInput
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useTranslation } from "@/langs/useTranslation";
import ConfigSwitch from "./common/ConfigSwitch";
import { IconTrash } from "@/components/Icon";
import { FormItem } from "@/components/Form";
import { uuid } from "@/helpers/utils";
import styles from "./index.module.less";

const WifiConfigItem = ({ index, values, onChange, readOnly }) => {
  const { t } = useTranslation();

  const [showPassword, setShowPassword] = React.useState(false);

  const handleChange = (value, type) => {
    onChange({
      target: {
        name: `wifi.wifis[${index}].${type}`,
        value
      }
    });
  };

  const handleDelete = () => {
    onChange({
      target: {
        name: "wifi.wifis",
        value: values.wifis.filter((_, i) => i !== index)
      }
    });
  };

  return (
    <div
      className={styles.card}
      style={{ marginBottom: index === values.wifis.length - 1 ? "" : 24 }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={1.5}
      >
        <Typography variant="h6">Wi-Fi {index + 1}</Typography>
        <IconButton onClick={handleDelete}>
          <IconTrash size={16} color="#ff0000" />
        </IconButton>
      </Box>
      <FormItem
        label={t({ defaultMessage: "SSID" })}
        required
        colon
        row
        labelBold
      >
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          readOnly={readOnly}
          placeholder={t({ defaultMessage: "请输入" })}
          value={values.wifis[index].ssid}
          onChange={e => handleChange(e.target.value, "ssid")}
        />
      </FormItem>
      <FormItem
        label={t({ defaultMessage: "密码" })}
        required
        colon
        row
        labelBold
        style={{ marginBottom: 0 }}
      >
        <FormControl fullWidth size="small" variant="outlined">
          <OutlinedInput
            type={showPassword ? "text" : "password"}
            placeholder={t({ defaultMessage: "请输入" })}
            readOnly={readOnly}
            value={values.wifis[index].password}
            onChange={e => handleChange(e.target.value, "password")}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  onMouseDown={e => e.preventDefault()}
                  edge="end"
                >
                  {showPassword ? (
                    <Visibility style={{ fontSize: "1.2rem" }} />
                  ) : (
                    <VisibilityOff style={{ fontSize: "1.2rem" }} />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </FormItem>
    </div>
  );
};

const WifiConfig = ({ values, onChange, readOnly }) => {
  const { t } = useTranslation();

  const handleAddWifi = () => {
    onChange({
      target: {
        name: "wifi.wifis",
        value: [
          ...values.wifis,
          {
            ssid: "",
            password: "",
            id: uuid()
          }
        ]
      }
    });
  };

  return (
    <Box flex={1}>
      <Typography variant="h5" style={{ marginBottom: 32 }}>
        Wi-Fi
      </Typography>
      <ConfigSwitch
        title={t({ defaultMessage: "是否启用" })}
        name="wifi.open"
        readOnly={readOnly}
        onChange={onChange}
        marginBottom={3}
        value={values.open}
      />
      {values.open && (
        <>
          <ConfigSwitch
            title={t({ defaultMessage: "是否仅允许以下网络连接" })}
            titleVariant="subtitle1"
            titleBold
            readOnly={readOnly}
            name="wifi.only_allow_configuration_of_network_connections"
            onChange={onChange}
            value={values.only_allow_configuration_of_network_connections}
          />
          <Button
            color="primary"
            variant="outlined"
            size="large"
            style={{ margin: "24px 0" }}
            onClick={handleAddWifi}
          >
            {t({ defaultMessage: "添加Wi-Fi" })}
          </Button>

          {values.wifis.map((wifi, index) => (
            <WifiConfigItem
              name="wifi.wifis"
              key={wifi.id}
              index={index}
              values={values}
              onChange={onChange}
              readOnly={readOnly}
            />
          ))}
        </>
      )}
    </Box>
  );
};

export const initValues = {
  open: false,
  only_allow_configuration_of_network_connections: false,
  wifis: []
};

export default WifiConfig;
